import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

interface ArticleCardProps {
  slug: string;
  title: string;
  excerpt: string;
  category: string;
  date: string;
  readTime: number;
  image: string;
  featured?: boolean;
}

export default function ArticleCard({
  slug,
  title,
  excerpt,
  category,
  date,
  readTime,
  image,
  featured,
}: ArticleCardProps) {
  const cat = categories.find((c) => c.slug === category);
  const catName = cat?.name || category;

  return (
    <Link
      to={`/article/${slug}`}
      className={`group block bg-background-50 rounded-xl border border-background-200/70 overflow-hidden transition-all duration-300 hover:border-background-300/60 cursor-pointer ${
        featured ? 'lg:col-span-2 lg:flex' : ''
      }`}
    >
      <div className={`relative overflow-hidden ${featured ? 'lg:w-1/2 lg:min-h-64' : 'aspect-[16/10]'}`}>
        <img
          src={image}
          alt={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className={`p-5 flex flex-col justify-center ${featured ? 'lg:w-1/2' : ''}`}>
        <div className="flex items-center gap-3 mb-3">
          <span className="text-xs font-medium px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-800 whitespace-nowrap">
            {catName}
          </span>
          <span className="text-xs text-foreground-500">{date}</span>
          <span className="text-xs text-foreground-400">{readTime} 分钟阅读</span>
        </div>
        <h3 className={`font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors ${
          featured ? 'text-xl md:text-2xl' : 'text-base md:text-lg'
        }`}>
          {title}
        </h3>
        <p className="text-sm text-foreground-600 leading-relaxed line-clamp-3">{excerpt}</p>
      </div>
    </Link>
  );
}